/* Bene · performance helpers (Fase 1 + 2.3)
 * 1) Vídeos: fixa a variante HLS adequada (480p no mobile, 720p no desktop) lendo a playlist mestre — sem ABR,
 *    só começa a baixar quando necessário (hero: depois da página pintar; demais: ao entrar na tela)
 *    e pausa vídeos fora da tela. Marcação: <video data-bene-video="hero|lazy"> com <source data-src data-mime data-h>.
 *    Modo "prefer": <div data-bene-video-scope> — vídeos já com src (video_tag) têm as fontes acima do alvo removidas.
 *    Navegadores sem HLS nativo (Chrome/Firefox/Edge): carrega o hls.js (light) sob demanda, só quando um vídeo
 *    vai tocar, e reproduz a variante fixa; se o hls.js falhar, cai no MP4 (desktop) ou fica no poster (mobile).
 *    Vídeos inseridos depois por JS (ex.: carrossel de vídeos do produto) são detectados por MutationObserver.
 * 2) KaChing: libera a reserva de altura do bloco de bundles (feita inline no product-info) quando o app renderizar.
 */
(function () {
  'use strict';
  var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };
  var saveData = !!(navigator.connection && navigator.connection.saveData);

  // Teto de altura: 480p no mobile / 720p no desktop.
  function targetHeight() { return (mq.matches || saveData) ? 480 : 720; }
  // Altura que o elemento realmente exibe (em pixels físicos) — a variante escolhida é a menor que cobre isso,
  // sem passar do teto (ex.: miniaturas de 150 px do carrossel ficam em 480p mesmo no desktop; o hero fica em 720p).
  function neededHeight(video) {
    if (!video || !video.getBoundingClientRect) return 0;
    var h = video.getBoundingClientRect().height * (window.devicePixelRatio || 1);
    return h > 0 ? Math.ceil(h) : 0;
  }

  function heightOf(src) {
    var h = parseInt(src.getAttribute('data-h') || '', 10);
    if (h) return h;
    var m = /(\d{3,4})p/i.exec(src.getAttribute('data-src') || src.getAttribute('src') || '');
    return m ? parseInt(m[1], 10) : 0;
  }
  function isHls(src) { return /mpegurl|m3u8/i.test((src.getAttribute('data-mime') || src.getAttribute('type') || '') + (src.getAttribute('data-src') || src.getAttribute('src') || '')); }

  function canPlayHls(video) {
    return !!(video.canPlayType('application/vnd.apple.mpegurl') || video.canPlayType('application/x-mpegURL'));
  }
  // hls.js (build light, versão fixa) — carregado uma única vez, e só quando o primeiro vídeo precisar
  var HLS_JS_URL = 'https://cdn.jsdelivr.net/npm/hls.js@1.7.3/dist/hls.light.min.js';
  var hlsJsPromise = null;
  function loadHlsJs() {
    if (window.Hls) return Promise.resolve(window.Hls);
    if (hlsJsPromise) return hlsJsPromise;
    hlsJsPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = HLS_JS_URL; s.async = true;
      s.onload = function () { window.Hls ? resolve(window.Hls) : reject(new Error('hls.js indisponível')); };
      s.onerror = function () { hlsJsPromise = null; reject(new Error('hls.js não carregou')); };
      document.head.appendChild(s);
    });
    return hlsJsPromise;
  }
  function mp4Url(x) { return x.s.getAttribute('data-src') || x.s.getAttribute('src'); }
  // Lê a playlist mestre do HLS e devolve a URL de UMA variante (sem ABR: qualidade fixa e previsível):
  // a menor variante com altura >= need (o que o elemento exibe), limitada ao teto; sem candidata, a maior <= teto; senão a menor de todas.
  function pickHlsVariant(masterUrl, cap, need) {
    masterUrl = new URL(masterUrl, location.href).href; // URLs da Shopify vêm sem protocolo (//cdn...)
    return fetch(masterUrl, { mode: 'cors', cache: 'force-cache' }).then(function (r) { return r.text(); }).then(function (txt) {
      var lines = txt.split(/\r?\n/), list = [];
      for (var i = 0; i < lines.length - 1; i++) {
        var m = /RESOLUTION=(\d+)x(\d+)/.exec(lines[i]);
        if (!m) continue;
        var url = (lines[i + 1] || '').trim();
        if (!url || url.charAt(0) === '#') continue;
        list.push({ h: parseInt(m[2], 10), url: url });
      }
      if (!list.length) return masterUrl;
      list.sort(function (a, b) { return a.h - b.h; });
      var pick = null;
      for (var j = 0; j < list.length; j++) { if (list[j].h <= cap && list[j].h >= (need || 0)) { pick = list[j]; break; } }
      if (!pick) { for (var k = list.length - 1; k >= 0; k--) { if (list[k].h <= cap) { pick = list[k]; break; } } }
      if (!pick) pick = list[0];
      return new URL(pick.url, masterUrl).href;
    });
  }
  // Escolhe a fonte: MP4 <= alvo se existir; senão a variante HLS fixa (480p mobile / 720p desktop) — nativa no Safari,
  // via hls.js nos demais. Fallback (sem HLS possível): menor MP4 no desktop; no mobile fica só o poster.
  // Devolve {kind: 'native'|'hlsjs', url, fallback} ou null.
  function pickSource(video) {
    var srcs = Array.prototype.slice.call(video.querySelectorAll('source'));
    if (!srcs.length) return Promise.resolve(null);
    var t = targetHeight(), need = neededHeight(video);
    var hls = srcs.filter(isHls)[0];
    var mp4 = srcs.filter(function (s) { return !isHls(s); }).map(function (s) { return { s: s, h: heightOf(s) }; });
    var mp4Small = mp4.filter(function (x) { return x.h && x.h <= t; }).sort(function (a, b) { return b.h - a.h; })[0];
    if (mp4Small) return Promise.resolve({ kind: 'native', url: mp4Url(mp4Small) });
    var smallest = mp4.sort(function (a, b) { return a.h - b.h; })[0];
    var fallback = (!mq.matches && smallest) ? mp4Url(smallest) : null;   // mobile sem HLS: só 1080p disponível → mantém o poster
    if (!hls) return Promise.resolve(fallback ? { kind: 'native', url: fallback } : null);
    var master = hls.getAttribute('data-src') || hls.getAttribute('src');
    var native = canPlayHls(video);
    return pickHlsVariant(master, t, need).then(function (url) {
      return { kind: native ? 'native' : 'hlsjs', url: url, fallback: fallback };
    }).catch(function () {
      if (native) return { kind: 'native', url: master, fallback: fallback };
      return fallback ? { kind: 'native', url: fallback } : null;
    });
  }

  function playIfAuto(video) {
    // autoplay, ou o usuário já pediu play antes de a fonte estar pronta
    if (video.autoplay || video.hasAttribute('autoplay') || video.__beneWantPlay) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
  }
  function attachNative(video, url) {
    video.src = url;
    video.load();
    playIfAuto(video);
  }
  // Reproduz a variante HLS escolhida com hls.js (uma playlist de mídia = um nível só, sem ABR)
  function attachHlsJs(video, pick) {
    var useFallback = function () { if (pick.fallback) attachNative(video, pick.fallback); };
    loadHlsJs().then(function (Hls) {
      if (!Hls.isSupported()) { useFallback(); return; }
      var auto = video.autoplay || video.hasAttribute('autoplay');
      // sem autoplay (ex.: grid social com botão de play): não baixa nenhum segmento até o usuário dar play
      var hls = new Hls({ maxBufferLength: 12, maxMaxBufferLength: 20, backBufferLength: 10, enableWorker: true, autoStartLoad: auto });
      video.__beneHls = hls;
      if (!auto) video.addEventListener('play', function () { try { hls.startLoad(); } catch (e) {} }, { once: true });
      hls.on(Hls.Events.MANIFEST_PARSED, function () { playIfAuto(video); });
      hls.on(Hls.Events.ERROR, function (_, data) {
        if (!data || !data.fatal) return;
        try { hls.destroy(); } catch (e) {}
        video.__beneHls = null;
        useFallback();
      });
      hls.attachMedia(video);
      hls.loadSource(pick.url);
    }).catch(useFallback);
  }

  function startVideo(video) {
    if (video.__beneStarted) return;
    video.__beneStarted = true;
    applyPoster(video);
    video.addEventListener('play', function () { video.__beneWantPlay = true; });
    video.addEventListener('pause', function () { video.__beneWantPlay = false; });
    pickSource(video).then(function (pick) {
      if (!pick || !pick.url) return;
      video.addEventListener('playing', function () { video.classList.add('is-playing'); }, { once: true });
      if (pick.kind === 'hlsjs') attachHlsJs(video, pick); else attachNative(video, pick.url);
    });
  }

  function applyPoster(v) {
    var p = v.getAttribute('data-poster');
    if (p && !v.getAttribute('poster')) v.setAttribute('poster', p);
  }

  function initLazyVideos() {
    var vids = Array.prototype.slice.call(document.querySelectorAll('video[data-bene-video]'));
    if (!vids.length) return;
    var hasIO = 'IntersectionObserver' in window;
    // começa quando se aproxima da tela
    var startIO = hasIO ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { startVideo(e.target); startIO.unobserve(e.target); } });
    }, { rootMargin: '250px 0px' }) : null;
    // vídeos de autoplay (fundo/decorativos): pausa fora da tela / retoma dentro (economiza CPU, bateria e dados).
    // Vídeos que o usuário deu play (ex.: grid social, com som) não são tocados aqui.
    var visIO = hasIO ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target; if (!v.__beneStarted) return;
        if (!(v.autoplay || v.hasAttribute('autoplay'))) return;
        if (e.isIntersecting) {
          if (v.__beneHls) { try { v.__beneHls.startLoad(); } catch (err) {} }
          if (v.paused) playIfAuto(v);
        } else {
          if (!v.paused) v.pause();
          if (v.__beneHls) { try { v.__beneHls.stopLoad(); } catch (err) {} }
        }
      });
    }, { threshold: 0.05 }) : null;

    // poster dos vídeos lazy: só baixa quando o vídeo se aproxima da tela (não compete com a imagem do LCP no 4G)
    var posterIO = hasIO ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { applyPoster(e.target); posterIO.unobserve(e.target); } });
    }, { rootMargin: '900px 0px' }) : null;

    vids.forEach(function (v) {
      if (v.__beneInit) return; v.__beneInit = true;
      var mode = v.getAttribute('data-bene-video');
      if (v.hasAttribute('data-poster')) { if (posterIO && mode !== 'hero') posterIO.observe(v); else applyPoster(v); }
      if (mode === 'hero') {
        // Acima da dobra: o LCP é o <img> de poster atrás do vídeo. O <video> não pode ter 'poster',
        // senão o Chrome o trata como candidato LCP e atualiza o tempo quando o primeiro frame pinta.
        v.removeAttribute('poster');
        var go = function () { setTimeout(function () { startVideo(v); }, 250); };
        if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
      } else if (startIO) { startIO.observe(v); } else { startVideo(v); }
      if (visIO) visIO.observe(v);
    });
  }

  // Vídeos gerados por video_tag (já com src): remove fontes acima do alvo antes de tocar
  function initPreferScopes() {
    var scopes = document.querySelectorAll('[data-bene-video-scope]');
    Array.prototype.forEach.call(scopes, function (scope) {
      Array.prototype.forEach.call(scope.querySelectorAll('video'), function (v) {
        if (v.__benePrefer) return; v.__benePrefer = true;
        var srcs = Array.prototype.slice.call(v.querySelectorAll('source'));
        var t = targetHeight();
        var mp4 = srcs.filter(function (s) { return !isHls(s) && heightOf(s) > 0; });
        var keep = mp4.filter(function (s) { return heightOf(s) <= t; });
        if (!keep.length || keep.length === mp4.length) return;
        var removed = 0;
        mp4.forEach(function (s) { if (heightOf(s) > t) { s.parentNode.removeChild(s); removed++; } });
        if (removed && v.readyState === 0 && !v.currentTime) v.load();
      });
    });
  }

  // KaChing: a reserva de altura é feita por um script inline ao lado do slot (product-info.liquid), durante o parse.
  // Aqui só liberamos a reserva quando o app renderizar (ou após 6 s), e imediatamente se não houver reserva.
  function initKachingSlots() {
    var slots = document.querySelectorAll('[data-bene-kc-slot]');
    Array.prototype.forEach.call(slots, function (slot) {
      if (slot.__beneKc) return; slot.__beneKc = true;
      var release = function () { slot.classList.add('is-ready'); slot.style.minHeight = ''; };
      if (!slot.style.minHeight) { release(); return; }        // sem oferta para este produto: nada reservado
      var check = function () {
        var ui = slot.querySelector('.kaching-bundles, [class*="kaching-bundles__"]');
        if (ui && ui.getBoundingClientRect().height > 40) { release(); return true; }
        return false;
      };
      if (check()) return;
      var mo = 'MutationObserver' in window ? new MutationObserver(function () { if (check()) mo.disconnect(); }) : null;
      if (mo) mo.observe(slot, { childList: true, subtree: true, attributes: true });
      setTimeout(function () { if (mo) mo.disconnect(); release(); }, 6000);
    });
  }

  function watchDynamicVideos() {
    if (!('MutationObserver' in window) || !document.body) return;
    var pending = false;
    new MutationObserver(function (muts) {
      if (pending) return;
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if ((n.matches && n.matches('video[data-bene-video]')) || (n.querySelector && n.querySelector('video[data-bene-video]'))) {
            pending = true;
            setTimeout(function () { pending = false; initLazyVideos(); }, 0);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  // ---- jQuery + Slick sob demanda (Fase 3.1): só o carrinho usa (slider de upsell, toggles do custom.js)
  var jqPromise = null, jqWaiters = [];
  function loadScript(src) { return new Promise(function (res, rej) { var el = document.createElement('script'); el.src = src; el.async = false; el.onload = res; el.onerror = rej; document.head.appendChild(el); }); }
  window.beneEnsureJQ = function (cb) {
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) { if (cb) cb(); return Promise.resolve(); }
    var v = window.beneVendor || {};
    if (!jqPromise) {
      if (v.slickCss && !document.querySelector('link[href="' + v.slickCss + '"]')) { var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = v.slickCss; document.head.appendChild(l); }
      jqPromise = loadScript(v.jq).then(function () { return loadScript(v.slick); }).then(function () {
        var w = jqWaiters; jqWaiters = []; w.forEach(function (f) { try { f(); } catch (e) { console.error(e); } });
      }).catch(function (e) { console.error('[bene-perf] jQuery/Slick não carregou', e); jqPromise = null; });
    }
    if (cb) jqWaiters.push(cb);
    return jqPromise;
  };
  // roda cb quando (e se) o jQuery for carregado por alguém; se já estiver, roda agora
  window.beneOnJQ = function (cb) {
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) { cb(); return; }
    jqWaiters.push(cb);
  };

  function init() {
    initLazyVideos(); initPreferScopes(); initKachingSlots();
    if (window.beneVendor && window.beneVendor.eager) window.beneEnsureJQ();   // template do carrinho: custom.js precisa do jQuery
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); watchDynamicVideos(); });
  else { init(); watchDynamicVideos(); }
  document.addEventListener('shopify:section:load', init);
})();
